import React from 'react'
import ModalFormUI from '../../../widgets/form/ModalFormUI'
import InputTextSF from '../../../widgets/form/InputTextSF'
import InputSelectSF from '../../../widgets/form/InputSelectSF'

const MCAParameterUpdateModalUI = ({ context, successMsg, errorList, setErrorList,
  // modes
  updateMode, submitted,
  // event handlers
  onSubmit, onCancelClick,
  // superuser role
  financialYear, onFinancialYearChange, financialYearError, setFinancialYearError, yearList,
  parameterValue, onParameterValueChange, parameterValueError, setParameterValueError
}) =>
  <ModalFormUI
    context={context}
    titleLabel='MCA parameter update'
    buttonLabel='Update'
    cancelLabel='Cancel'
    isOpen={updateMode}
    onRequestClose={onCancelClick}
    successMsg={successMsg}
    errorList={errorList}
    setErrorList={setErrorList}
    onSubmit={onSubmit}
    busy={submitted}
  >
    <InputSelectSF type='select' name='financialYear' label='Financial year'
      required={true} autoFocus={true}
      value={financialYear} onChange={onFinancialYearChange} optionList={yearList}
      error={financialYearError} setError={setFinancialYearError}
    />
    <InputTextSF type='text' name='parameterValue' label='Parameter value'
      required={true}
      value={parameterValue} onChange={onParameterValueChange}
      error={parameterValueError} setError={setParameterValueError}
    />
  </ModalFormUI>

export default MCAParameterUpdateModalUI
